import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import './ConsultoriaTecnologicaPage.css';

const ConsultoriaTecnologicaPage = ({ darkMode, toggleDarkMode }) => {
  const beneficios = [
    {
      icon: '🎯',
      titulo: 'Visión Estratégica',
      descripcion: 'Identificamos oportunidades tecnológicas que impulsan tu negocio y te dan ventaja competitiva.'
    },
    {
      icon: '📊',
      titulo: 'Análisis Objetivo',
      descripcion: 'Evaluación independiente de tu situación tecnológica actual sin sesgos ni intereses comerciales.'
    },
    {
      icon: '🗺️',
      titulo: 'Roadmap Claro',
      descripcion: 'Plan de acción priorizado con pasos concretos, plazos y ROI estimado para cada iniciativa.'
    },
    {
      icon: '💰',
      titulo: 'Optimización de Inversión',
      descripcion: 'Aseguras que cada euro invertido en tecnología genera el máximo retorno para tu negocio.'
    },
    {
      icon: '⚡',
      titulo: 'Aceleración de Proyectos',
      descripcion: 'Evitas errores costosos y aceleras la implementación con la experiencia de expertos.'
    },
    {
      icon: '🛡️',
      titulo: 'Reducción de Riesgos',
      descripcion: 'Identificamos y mitigamos riesgos tecnológicos antes de que se conviertan en problemas.'
    }
  ];

  const tiposConsultoria = [
    {
      titulo: 'Auditoría Tecnológica',
      descripcion: 'Evaluación completa de tu infraestructura IT, sistemas, procesos y seguridad para identificar fortalezas y debilidades.',
      entregables: [
        'Informe de estado actual',
        'Análisis de brechas tecnológicas',
        'Evaluación de riesgos',
        'Recomendaciones priorizadas'
      ]
    },
    {
      titulo: 'Estrategia de Transformación Digital',
      descripcion: 'Diseño de roadmap de transformación digital adaptado a tu empresa, sector y objetivos de negocio.',
      entregables: [
        'Roadmap de transformación',
        'Plan de implementación por fases',
        'ROI estimado por iniciativa',
        'Cronograma y recursos necesarios'
      ]
    },
    {
      titulo: 'Selección de Tecnologías',
      descripcion: 'Asesoramiento para elegir las mejores tecnologías, software y proveedores según tus necesidades y presupuesto.',
      entregables: [
        'Análisis comparativo de opciones',
        'Recomendación fundamentada',
        'Análisis de costos',
        'Plan de migración'
      ]
    },
    {
      titulo: 'Arquitectura de Sistemas',
      descripcion: 'Diseño de arquitectura tecnológica escalable, segura y eficiente para soportar el crecimiento de tu empresa.',
      entregables: [
        'Diseño de arquitectura',
        'Especificaciones técnicas',
        'Plan de implementación',
        'Recomendaciones de infraestructura'
      ]
    },
    {
      titulo: 'Optimización de Procesos IT',
      descripcion: 'Mejora de procesos IT existentes para aumentar eficiencia, reducir costos y mejorar la calidad del servicio.',
      entregables: [
        'Análisis de procesos actuales',
        'Propuesta de mejoras',
        'Plan de implementación',
        'Métricas de éxito'
      ]
    },
    {
      titulo: 'Ciberseguridad y Cumplimiento',
      descripcion: 'Evaluación de seguridad, identificación de vulnerabilidades y plan de cumplimiento normativo (RGPD, LOPD).',
      entregables: [
        'Auditoría de seguridad',
        'Plan de mejora de seguridad',
        'Estrategia de cumplimiento',
        'Políticas y procedimientos'
      ]
    }
  ];

  const proceso = [
    {
      paso: '1',
      titulo: 'Consulta Inicial',
      descripcion: 'Reunión para entender tu negocio, objetivos, desafíos tecnológicos y expectativas del proyecto.'
    },
    {
      paso: '2',
      titulo: 'Análisis y Diagnóstico',
      descripcion: 'Evaluación exhaustiva de tu situación tecnológica actual: sistemas, procesos, infraestructura y equipo.'
    },
    {
      paso: '3',
      titulo: 'Diseño de Solución',
      descripcion: 'Desarrollo de estrategia y recomendaciones personalizadas con roadmap, prioridades y ROI estimado.'
    },
    {
      paso: '4',
      titulo: 'Presentación y Validación',
      descripcion: 'Presentación de resultados, discusión de opciones y ajustes según tu feedback y prioridades.'
    },
    {
      paso: '5',
      titulo: 'Acompañamiento en Implementación',
      descripcion: 'Soporte durante la implementación de las recomendaciones para asegurar el éxito del proyecto.'
    }
  ];

  const casosUso = [
    {
      titulo: 'Empresa en Crecimiento',
      descripcion: 'Necesitas escalar tu infraestructura IT pero no sabes por dónde empezar. La consultoría te ayuda a planificar el crecimiento tecnológico.'
    },
    {
      titulo: 'Migración a Cloud',
      descripcion: 'Quieres migrar a la nube pero necesitas asesoramiento sobre qué servicios elegir, cómo migrar y qué costos esperar.'
    },
    {
      titulo: 'Modernización de Sistemas',
      descripcion: 'Tus sistemas están obsoletos y necesitas un plan para modernizarlos sin interrumpir el negocio.'
    },
    {
      titulo: 'Optimización de Costos IT',
      descripcion: 'Los costos IT crecen sin control. La consultoría identifica oportunidades de ahorro y optimización.'
    },
    {
      titulo: 'Cumplimiento Normativo',
      descripcion: 'Necesitas cumplir con RGPD, LOPD u otras normativas pero no sabes qué hacer. La consultoría te guía paso a paso.'
    },
    {
      titulo: 'Selección de ERP o Software',
      descripcion: 'Necesitas elegir un ERP o software pero hay muchas opciones. La consultoría te ayuda a tomar la decisión correcta.'
    }
  ];

  const sectores = [
    {
      titulo: 'Retail y E-commerce',
      descripcion: 'Consultoría para optimizar sistemas de venta, inventario, e-commerce y experiencia del cliente.'
    },
    {
      titulo: 'Servicios Profesionales',
      descripcion: 'Estrategia tecnológica para despachos, consultorías y empresas de servicios profesionales.'
    },
    {
      titulo: 'Hostelería y Turismo',
      descripcion: 'Transformación digital para hoteles, restaurantes y empresas turísticas.'
    },
    {
      titulo: 'Manufactura',
      descripcion: 'Consultoría IT para optimizar sistemas de producción, calidad y gestión industrial.'
    },
    {
      titulo: 'Salud',
      descripcion: 'Estrategia tecnológica con cumplimiento normativo para clínicas y centros de salud.'
    },
    {
      titulo: 'Educación',
      descripcion: 'Consultoría para modernizar sistemas educativos, plataformas de formación y gestión académica.'
    }
  ];

  return (
    <>
      <SEO 
        title="Consultoría tecnológica para empresas | E-ASY"
        description="Consultoría tecnológica para empresas: auditoría IT, transformación digital, selección de tecnología y arquitectura de sistemas. Trabajamos en remoto en toda España desde nuestra sede en Tenerife."
        keywords="consultoría tecnológica, consultoría tecnológica para empresas, consultoría IT, consultoría informática, auditoría tecnológica, transformación digital, consultoría IT España"
        canonical="https://e-asy.es/servicios/consultoria-tecnologica"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`consultoria-tecnologica-page ${darkMode ? 'dark' : 'light'}`}>
        
        {/* Hero Section */}
        <section className="consultoria-hero">
          <div className="consultoria-hero-content">
            <div className="consultoria-hero-text">
              <h1 className="consultoria-hero-title">Consultoría Tecnológica para Empresas</h1>
              <p className="consultoria-hero-subtitle">
                E-ASY ofrece <strong>consultoría tecnológica</strong> para empresas que necesitan una visión estratégica 
                de su tecnología. <strong>Auditorías IT</strong>, <strong>estrategia de transformación digital</strong>, 
                <strong>selección de tecnologías</strong> y <strong>arquitectura de sistemas</strong>.
              </p>
              <p className="consultoria-hero-subtitle">
                Trabajamos en remoto con empresas de toda <strong>España</strong> desde nuestra sede en <strong>Tenerife</strong>. La primera consulta sirve para entender la situación y proponer una estrategia tecnológica concreta.
              </p>
              <div className="consultoria-hero-cta">
                <Link to="/contacto" className="consultoria-hero-button primary">
                  Agenda una consultoría gratuita
                </Link>
                <Link to="/servicios" className="consultoria-hero-button secondary">
                  Ver todos los servicios
                </Link>
              </div>
            </div>
            <div className="consultoria-hero-visual">
              <div className="consultoria-hero-graphic">
                <div className="consulting-animation">
                  <div className="consulting-chart">
                    <div className="chart-bar bar-1"></div>
                    <div className="chart-bar bar-2"></div>
                    <div className="chart-bar bar-3"></div>
                    <div className="chart-bar bar-4"></div>
                  </div>
                  <div className="consulting-arrow">
                    <div className="arrow-line"></div>
                    <div className="arrow-head"></div>
                  </div>
                  <div className="consulting-target">
                    <div className="target-circle"></div>
                    <div className="target-center"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Qué es Section */}
        <section className="consultoria-que-es">
          <div className="consultoria-que-es-content">
            <div className="consultoria-que-es-header">
              <h2 className="consultoria-que-es-title">¿Qué es la Consultoría Tecnológica?</h2>
              <p className="consultoria-que-es-subtitle">
                La <strong>consultoría tecnológica</strong> es un servicio de asesoramiento estratégico que ayuda a las empresas 
                a tomar decisiones informadas sobre tecnología. Un <strong>consultor tecnológico</strong> analiza tu situación actual, 
                identifica oportunidades y diseña una estrategia para alcanzar tus objetivos tecnológicos.
              </p>
              <p className="consultoria-que-es-subtitle">
                Si tu empresa necesita <strong>modernizar sistemas</strong>, <strong>optimizar costos IT</strong>, 
                <strong>implementar nuevas tecnologías</strong> o <strong>planificar la transformación digital</strong>, 
                la <strong>consultoría tecnológica</strong> te proporciona el roadmap y la estrategia necesarios.
              </p>
            </div>
          </div>
        </section>

        {/* Beneficios Section */}
        <section className="consultoria-beneficios">
          <div className="consultoria-beneficios-content">
            <div className="consultoria-beneficios-header">
              <h2 className="consultoria-beneficios-title">Beneficios de la Consultoría Tecnológica</h2>
              <p className="consultoria-beneficios-subtitle">
                Ventajas de contar con asesoramiento tecnológico estratégico
              </p>
            </div>
            <div className="consultoria-beneficios-grid">
              {beneficios.map((beneficio, index) => (
                <div key={index} className="consultoria-beneficio-card">
                  <div className="beneficio-icon">{beneficio.icon}</div>
                  <h3 className="beneficio-title">{beneficio.titulo}</h3>
                  <p className="beneficio-description">{beneficio.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Tipos de Consultoría Section */}
        <section className="consultoria-tipos">
          <div className="consultoria-tipos-content">
            <div className="consultoria-tipos-header">
              <h2 className="consultoria-tipos-title">Tipos de Consultoría que Ofrecemos</h2>
              <p className="consultoria-tipos-subtitle">
                Servicios de consultoría tecnológica adaptados a diferentes necesidades empresariales
              </p>
            </div>
            <div className="consultoria-tipos-grid">
              {tiposConsultoria.map((tipo, index) => (
                <div key={index} className="consultoria-tipo-card">
                  <h3 className="tipo-title">{tipo.titulo}</h3>
                  <p className="tipo-description">{tipo.descripcion}</p>
                  <div className="tipo-entregables">
                    <h4 className="entregables-title">Entregables:</h4>
                    <ul className="entregables-list">
                      {tipo.entregables.map((entregable, idx) => (
                        <li key={idx} className="entregable-item">{entregable}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Casos de Uso Section */}
        <section className="consultoria-casos">
          <div className="consultoria-casos-content">
            <div className="consultoria-casos-header">
              <h2 className="consultoria-casos-title">¿Cuándo Necesitas Consultoría Tecnológica?</h2>
              <p className="consultoria-casos-subtitle">
                Situaciones en las que la consultoría tecnológica puede ayudarte
              </p>
            </div>
            <div className="consultoria-casos-grid">
              {casosUso.map((caso, index) => (
                <div key={index} className="consultoria-caso-card">
                  <h3 className="caso-title">{caso.titulo}</h3>
                  <p className="caso-description">{caso.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Proceso Section */}
        <section className="consultoria-proceso">
          <div className="consultoria-proceso-content">
            <div className="consultoria-proceso-header">
              <h2 className="consultoria-proceso-title">Nuestro Proceso de Consultoría</h2>
              <p className="consultoria-proceso-subtitle">
                Metodología estructurada que asegura resultados claros y accionables
              </p>
            </div>
            <div className="consultoria-proceso-timeline">
              {proceso.map((item, index) => (
                <div key={index} className="proceso-step">
                  <div className="step-number">{item.paso}</div>
                  <div className="step-content">
                    <h3 className="step-title">{item.titulo}</h3>
                    <p className="step-description">{item.descripcion}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Sectores Section */}
        <section className="consultoria-sectores">
          <div className="consultoria-sectores-content">
            <div className="consultoria-sectores-header">
              <h2 className="consultoria-sectores-title">Consultoría Tecnológica para Diferentes Sectores</h2>
              <p className="consultoria-sectores-subtitle">
                Adaptamos nuestra consultoría a las necesidades específicas de cada sector
              </p>
            </div>
            <div className="consultoria-sectores-grid">
              {sectores.map((sector, index) => (
                <div key={index} className="consultoria-sector-card">
                  <h3 className="sector-title">{sector.titulo}</h3>
                  <p className="sector-description">{sector.descripcion}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="consultoria-que-es cobertura-servicio">
          <div className="consultoria-que-es-content">
            <div className="consultoria-que-es-header">
              <h2 className="consultoria-que-es-title">Consultoría tecnológica en toda España</h2>
              <p className="consultoria-que-es-subtitle">
                El diagnóstico, la selección de tecnología y el seguimiento se hacen en remoto. La oficina y la atención presencial están en Tenerife. El detalle está en{' '}
                <Link to="/donde-trabajamos">dónde trabajamos</Link>
                . Para proyectos locales de la isla, mantenemos la página de{' '}
                <Link to="/consultoria-tecnologica-tenerife">consultoría tecnológica en Tenerife</Link>.
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="consultoria-cta">
          <div className="consultoria-cta-content">
            <h2 className="consultoria-cta-title">¿Necesitas Consultoría Tecnológica para tu Empresa?</h2>
            <p className="consultoria-cta-subtitle">
              Agenda una consultoría gratuita y descubre cómo podemos ayudarte a definir tu estrategia tecnológica
            </p>
            <div className="consultoria-cta-buttons">
              <Link to="/contacto" className="consultoria-cta-button primary">
                Agenda una consultoría gratuita
              </Link>
              <Link to="/servicios" className="consultoria-cta-button secondary">
                Ver todos los servicios
              </Link>
            </div>
          </div>
        </section>

      </div>
      <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default ConsultoriaTecnologicaPage;






